export default __webpack_public_path__ + "static/media/origami-elephant.fa53994b.png";